import React from "react";
import Banner from "./Banner";
import About from "./About";
import Expertise from "./Expertise";
import GoogleReview from "./GoogleReview";
import WhySurya from "./WhySurya";
import InsureJewelry from "./InsureJewelry";
import Faq from "./Faq";
import {useEffect} from "react";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {useDispatch, useSelector} from "react-redux";

const Home = () => {
  const dispatch = useDispatch();
  const {showLoader} = useSelector(selectUiState);

  useEffect(() => {
    if (showLoader) {
      dispatch(
        setUiData({
          showLoader: false,
        })
      );
    }
  }, []);

  return (
    <>
      {/* <Header /> */}
      {/* <NewProposalForm /> */}
      {/* <Login/> */}
      {/* <ForgotPassword /> */}
      {/* <h1> Comming Soon </h1> */}
      {/* <Link to="/">     <img className={style.logLogoMain} src={Logo} /> </Link> */}
      {/* <div className="DemoHeader">
      <Link to="/login"> Login </Link>
      <Link to="/register"> Register </Link>
      <Link to="/forgot-password"> Forgot Password </Link>
      <Link to="/reset-password"> Reset Password </Link>
      <Link to="/dashboard"> Dashboard </Link>
    </div> */}
      <Banner />
      <Expertise />
      <About />
      <InsureJewelry />
      <WhySurya />

      <GoogleReview />
      {/* <Blogs /> */}
      <Faq />
      {/* <Footer /> */}
    </>
  );
};

export default Home;
